<template>
    <div class="Warp">
    <van-notice-bar color="#1989fa" background="#ecf9ff">
      卡券领取详情
    </van-notice-bar>
    <van-cell-group>
        <van-cell title="消费者姓名" :value="detail.name||'暂无信息'" />
        <van-cell title="消费者电话" :value="detail.tel||'暂无信息'" />
       <van-cell title="卡券编号" :value="detail.card_num||'暂无信息'" />
        <van-cell title="卡券名称" :value="detail.title||'暂无信息'" />
        <van-cell title="卡券类型" :value="detail.card_type=='FULL_REDUCE'?'满减':'折扣'" />
        <van-cell title="卡券介绍" :label="detail.description||'暂无信息'" />
        <van-cell title="消费者满多少" :value="detail.consumer_full_money||'暂无信息'" />
        <van-cell title="消费者减多少" :value="detail.consumer_reduce_money||'暂无信息'" />
        <van-cell title="领取时间" :value="detail.receive_time||'暂无信息'" />
        <van-cell title="使用状态"  :value="detail.use_status==1?'已核销':'未使用'" />
        <van-cell title="使用时间" v-if="detail.use_status==1" :value="detail.limit_date_type||'暂无信息'" />
    </van-cell-group>
    </div>
</template>
<script>
export default {
    data(){
        return {
            detail:{}
        }
    },
    mounted(){
        this.getDetail();
    },
    methods:{
        getDetail(){
            this.detail = this.$route.query
            console.log(this.detail);
        },
    }
}
</script>
<style lang="less" scoped>
    .store{
        // text-align: right;
        margin-bottom:10px;
    }
</style>